import React, { createContext, useReducer, useContext, useEffect } from "react";
import { roleReducer, initialRoleState } from "./roleReducer";

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const [state, dispatch] = useReducer(roleReducer, initialRoleState);

  return (
    <RoleContext.Provider value={{ state, dispatch }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
